import { useSuspenseQuery } from '@tanstack/react-query'

import { regionQuery } from './region'

export const useRegion = (params: { regionId: string }) => {
  const { data: state } = useSuspenseQuery(regionQuery(params.regionId))
  return state
}
